// ABOUTME: Tab configuration for warehouse service desk / support ticket management.
// ABOUTME: Defines tabs for workscreen, open tickets, unassigned tickets, and settings.

import InboxIcon from '@mui/icons-material/Inbox';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';

// dashboardData: support ticket dashboard metrics; its counts become the view badges once loaded
export const warehouseRelationServiceConfig = (dashboardData) => {
    return {
        workscreen: {
            title: 'workscreen',
            icon: <InboxIcon/>,
            ...(dashboardData && {count: dashboardData.mineCount}),
        },
        opentickets: {
            title: 'open_tickets',
            icon: <ConfirmationNumberIcon/>,
            ...(dashboardData && {count: dashboardData.openCount}),
        },
        unassigned: {
            title: 'new_incoming',
            icon: <PersonOffIcon/>,
            ...(dashboardData && {count: dashboardData.unassignedCount}),
        },
        history: {
            title: 'history',
            icon: <HistoryIcon/>,
        },
        settings: {
            title: 'settings',
            icon: <SettingsIcon/>,
            position: 'right',
        },
    };
};
